import { render } from "./MiCardActions.vue?vue&type=template&id=42ee7bf0&scoped=true"
import script from "./MiCardActions.vue?vue&type=script&lang=js"
export * from "./MiCardActions.vue?vue&type=script&lang=js"

import "./MiCardActions.vue?vue&type=style&index=0&id=42ee7bf0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ee7bf0"]])

export default __exports__
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardActions,QBtn});
